import React, {FC} from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'

interface Props {
  name: string
  idIndex?: number
  idCurrent?: number
  closeTab?: boolean
  onclickD?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

const TabsContent: FC<Props> = ({name, closeTab, idCurrent, idIndex, onclickD}) => {
  let isMinusTab = idCurrent && idCurrent - 1
  let isActivetab = isMinusTab === idIndex || idCurrent === idIndex ? '' : 'sdx-border-left'
  let getSizeText = name.length > 35 ? name.length * 6 + 54 : name.length * 6 + 64 + 25
  return (
    <div
      className={'sdx_tab_panel_option_content ' + isActivetab}
      style={{minWidth: getSizeText + 'px'}}
    >
      <span>
        <b>{name}</b>
      </span>
      {closeTab && (
        <button className='btn p-0' style={{lineHeight: 1.3}} onClick={onclickD}>
          <KTSVG path='/media/icons/duotune/arrows/arr015.svg' className={'svg-icon-4'} />
        </button>
      )}
    </div>
  )
}

export {TabsContent}
